import { z } from 'zod';

export const DocumentsTypesScalarFieldEnumSchema = z.enum(['id','city_id','title','data','description','signature_contact_info','created_at','updated_at','form_fields_display','qr_code_display','qr_code_override_url','is_public','token']);

export default DocumentsTypesScalarFieldEnumSchema;
